const HTTPS = /^https:\/\/\S+$/;
const fullRow = button => button.title.trim() && HTTPS.test(button.url.trim());
const cleanMessage = message => ({ text: message.text, buttons: message.buttons.filter(fullRow).map(button => ({ title: button.title.trim(), url: button.url.trim() })) });

// What the API can store now: blank rows wait in the form, never in the request.
export const toRequest = draft => ({
  ...(draft.name.trim() ? { name: draft.name.trim() } : {}),
  trigger: draft.trigger,
  comment_reply: { ...draft.comment_reply, templates: draft.comment_reply.templates.map(item => item.trim()).filter(Boolean) },
  dm: { ...draft.dm, delivery: cleanMessage(draft.dm.delivery), reminder: { ...draft.dm.reminder, message: cleanMessage(draft.dm.reminder.message) } },
});

// A link typed halfway is not sent, so the form says what it lacks: [field, copy key] pairs.
export const halfRows = (path, message) => message.buttons.flatMap((button, index) => {
  if (!button.title.trim() && !button.url.trim()) return [];
  const errors = [];
  if (!button.title.trim()) errors.push([`${path}.buttons.${index}.title`, 'linkTitleRequired']);
  if (!HTTPS.test(button.url.trim())) errors.push([`${path}.buttons.${index}.url`, 'linkHttpsRequired']);
  return errors;
});
